export default __webpack_public_path__ + "static/albumNas-14983c84845e0b408a3f9b560b407798.svg";